var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcpDebugger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "none",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: "3.4,10.7 7.4,10.7 7.4,9.3 3.4,9.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: "2.6,18.4 9.2,11.8 8.3,10.9 1.7,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: "2,2.9 8.6,9.5 9.5,8.6 2.9,2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: "12.6,10.7 16.6,10.7 16.6,9.3 12.6,9.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: "10.8,11.8 17.1,18 18,17.1 11.8,10.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: "12.5,8.5 18.3,2.6 17.4,1.7 11.5,7.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: "-0.5,20.5 4,20.5 4,16 -0.5,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: "16,20.5 20.5,20.5 20.5,16 16,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: "-0.5,4 4,4 4,-0.5 -0.5,-0.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: "16,4 20.5,4 20.5,-0.5 16,-0.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fillRule: "evenodd",
    fill: "#85A4E6",
    points: "6.2,13.8 13.8,13.8 13.8,6.2 6.2,6.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: "-0.5,12.2 4,12.2 4,7.8 -0.5,7.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: "16,12.2 20.5,12.2 20.5,7.8 16,7.8  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpDebugger);
export default __webpack_public_path__ + "static/media/gcp-debugger.11e67149cbb49579bb607be4592c6214.svg";
export { ForwardRef as ReactComponent };